
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 480.005 480.005"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.003 0v64h16v272h168.352l-94.84 131.312a8.005 8.005 0 0012.976 9.376l89.512-123.944V472a8 8 0 0016 0V352.744l89.512 123.944a8.005 8.005 0 0012.976-9.376L255.651 336h168.352V64h16V0h-400zm368 320h-336V64h336v256zm16-272h-368V16h368v32z"}}),_c('path',{attrs:{"d":"M373.462 226.344a8.001 8.001 0 00-11.116 0l-58.344 58.344-18.344-18.344a8 8 0 00-11.312 0 8 8 0 000 11.312l24 24a8 8 0 0011.312 0l64-64a8 8 0 00-.196-11.312zM240.003 160h-8.472c-3.781-33.395-30.133-59.747-63.528-63.528V88a8 8 0 00-16 0v8.472c-39.504 4.544-67.845 40.252-63.301 79.756 4.17 36.255 34.807 63.657 71.301 63.772 36.645-.05 67.42-27.586 71.528-64h8.472a8 8 0 000-16zm-88 63.513c-30.617-4.376-51.889-32.743-47.513-63.36 3.521-24.636 22.878-43.992 47.513-47.513V168a8 8 0 008 8h55.36c-4.376 30.617-32.744 51.889-63.36 47.513zm16-63.513v-47.36c24.528 3.566 43.794 22.832 47.36 47.36h-47.36zM88.003 288h16v16h-16zM120.003 288h120v16h-120zM88.003 256h16v16h-16zM120.003 256h120v16h-120zM264.003 128h16v16h-16zM296.003 128h96v16h-96zM264.003 96h16v16h-16zM296.003 96h96v16h-96zM264.003 192h16v16h-16zM296.003 192h96v16h-96zM264.003 160h16v16h-16zM296.003 160h96v16h-96z"}})])
          )
        }
      }
    